var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuotes({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9298 2.03037C13.5439 3.15836 12.351 4.48372 12.351 6.00651C13.3679 6.11931 14.2088 6.5188 14.8738 7.20499C15.5387 7.89118 15.8712 8.68546 15.8712 9.58785C15.8712 10.5466 15.5485 11.355 14.9031 12.013C14.2577 12.671 13.4461 13 12.4683 13C11.3731 13 10.4246 12.5723 9.62279 11.7169C8.82096 10.8615 8.42005 9.82285 8.42005 8.60087C8.42005 4.93491 10.5517 2.06798 14.8151 0L15.9298 2.03037ZM7.50978 2.03037C5.10429 3.15836 3.90156 4.48372 3.90156 6.00651C4.93808 6.11931 5.78878 6.5188 6.45372 7.20499C7.11865 7.89118 7.45111 8.68546 7.45111 9.58785C7.45111 10.5466 7.12354 11.355 6.46838 12.013C5.81323 12.671 4.99675 13 4.0189 13C2.92372 13 1.98012 12.5723 1.18807 11.7169C0.39602 10.8615 0 9.82285 0 8.60087C0 4.93491 2.12188 2.06798 6.36571 0L7.50978 2.03037Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotes);
export default __webpack_public_path__ + "static/media/quotes.9e97bb220e3230f25d7e7028b41eff3c.svg";
export { ForwardRef as ReactComponent };